/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GiustificativiResponseDTO
 */
export interface GiustificativiResponseDTO {
    /**
     * 
     * @type {number}
     * @memberof GiustificativiResponseDTO
     */
    idLavoro?: number;
    /**
     * 
     * @type {number}
     * @memberof GiustificativiResponseDTO
     */
    idTipoRimborso?: number;
    /**
     * 
     * @type {Date}
     * @memberof GiustificativiResponseDTO
     */
    data?: Date;
    /**
     * 
     * @type {string}
     * @memberof GiustificativiResponseDTO
     */
    tipo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GiustificativiResponseDTO
     */
    note?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GiustificativiResponseDTO
     */
    valore?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GiustificativiResponseDTO
     */
    hasAllegati?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GiustificativiResponseDTO
     */
    idFileAllegato?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GiustificativiResponseDTO
     */
    localita?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GiustificativiResponseDTO
     */
    commessa?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GiustificativiResponseDTO
     */
    um?: string | null;
}

/**
 * Check if a given object implements the GiustificativiResponseDTO interface.
 */
export function instanceOfGiustificativiResponseDTO(value: object): value is GiustificativiResponseDTO {
    return true;
}

export function GiustificativiResponseDTOFromJSON(json: any): GiustificativiResponseDTO {
    return GiustificativiResponseDTOFromJSONTyped(json, false);
}

export function GiustificativiResponseDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): GiustificativiResponseDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'idLavoro': json['idLavoro'] == null ? undefined : json['idLavoro'],
        'idTipoRimborso': json['idTipoRimborso'] == null ? undefined : json['idTipoRimborso'],
        'data': json['data'] == null ? undefined : (new Date(json['data'])),
        'tipo': json['tipo'] == null ? undefined : json['tipo'],
        'note': json['note'] == null ? undefined : json['note'],
        'valore': json['valore'] == null ? undefined : json['valore'],
        'hasAllegati': json['hasAllegati'] == null ? undefined : json['hasAllegati'],
        'idFileAllegato': json['idFileAllegato'] == null ? undefined : json['idFileAllegato'],
        'localita': json['localita'] == null ? undefined : json['localita'],
        'commessa': json['commessa'] == null ? undefined : json['commessa'],
        'um': json['um'] == null ? undefined : json['um'],
    };
}

export function GiustificativiResponseDTOToJSON(json: any): GiustificativiResponseDTO {
    return GiustificativiResponseDTOToJSONTyped(json, false);
}

export function GiustificativiResponseDTOToJSONTyped(value?: GiustificativiResponseDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idLavoro': value['idLavoro'],
        'idTipoRimborso': value['idTipoRimborso'],
        'data': value['data'] == null ? undefined : ((value['data']).toISOString()),
        'tipo': value['tipo'],
        'note': value['note'],
        'valore': value['valore'],
        'hasAllegati': value['hasAllegati'],
        'idFileAllegato': value['idFileAllegato'],
        'localita': value['localita'],
        'commessa': value['commessa'],
        'um': value['um'],
    };
}

